{
  "nl": {
    "ticket_category": {
      "Decisions": "Beslissing",
      "Issue": "Nazorg",
      "Other": "Regulier",
      "actions": {
        "delete": "Gesprekscategorie verwijderen"
      },
      "inputs": {
        "empty": "Geen categorie"
      },
      "labels": {
        "delete": "Verwijder {category}",
        "delete_description": "Weet je zeker dat je {category} wilt verwijderen uit je gesprekscategorieën?",
        "ticket_categories": "Categorieën",
        "ticket_category": "Type"
      }
    }
  }
}
